import n from "mixpanel-browser";
var l;
((i) => {
  const p = {};
  function s(r, t, e = null, a = !1) {
    try {
      const o = r.VITE_MYASURION_MIXPANEL_TOKEN, u = r.BASE_URL, E = {
        userId: e,
        isProd: !a,
        path: u,
        partner: t.partner,
        program: t.program,
        // Props
        client: t.partner,
        country: "SG",
        env: r.VITE_ENV ?? "DEV",
        source: "MyAsurion-Web"
      };
      n.init(o, { debug: a }), n.identify(e), n.register(E);
    } catch {
      console.error("Failed in initialize Mixpanel Events");
    }
  }
  i.setupMixpanel = s;
  function c(r, t = {}) {
    let e = {};
    try {
      e = { ...p, ...t, millis: +/* @__PURE__ */ new Date() }, e.userId && n.identify(e.userId), n.track(r, e);
    } catch {
      console.error(`Failed to send Mixpanel data for event ${r}`);
    }
  }
  i.sendMixpanelEvent = c;
})(l || (l = {}));
export {
  l as Mixpanel
};
